import { TFunction } from "react-i18next";
import { Flash } from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { ConfirmationModalOptions } from "go-form/components/ModalConfirm";
import { apiOrganization } from "../../../../../../../services/Api/Organization/apiOrganization";

export const sendInvoiceToKSeFFromInvoicePreviewHandler = async (
	confirmation: (options: ConfirmationModalOptions) => Promise<void>,
	t: TFunction,
	invoiceId: number,
	addSuccessFlash: (_: string) => void,
	addFlash: (_: Flash) => void
) => {
	try {
		await confirmation({
			title: t("lib:confirmation.title"),
			message: t("lib:confirmation.message.action"),
		});
		await apiOrganization.sendInvoiceToKSeF(invoiceId);
		addSuccessFlash(t("lib:common.flash.completed"));
	} catch (e) {
		handleError.alert(e, addFlash);
	}
};
